import { useCallback, useState, useEffect } from 'react';

import fetchService, { sanitizeErrorMessage } from '@xanadu/ui-shared/utils/fetchService';

import { track } from '@xanadu/ui-shared/interfaces/woopra';

import { removeMarketingConsentDismissalDate } from '@xanadu/ui-shared/modules/user/api';

const useMarketingConsentReminder = (setShowMarketingConsentReminder, updateMarketingConsent) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const updateConsent = async () => {
    setLoading(true);

    try {
      const PUT_OPTIONS = {
        method: 'PUT',
        body: JSON.stringify({ 'marketing-consent': true }),
      };

      const response = await fetchService('/bpapi/rest/account', PUT_OPTIONS);

      if (response.id) {
        setSuccess(true);
        setError('');
        removeMarketingConsentDismissalDate();
        updateMarketingConsent(true);
        track('Marketing', 'Betslip Reminder - Marketing Consent - Opt In');
        return;
      }

      setError(sanitizeErrorMessage(response.errors));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Error updating marketing consent', e.message);
      setError('Unknown error');
    } finally {
      setLoading(false);
    }
  };

  const optIn = useCallback(() => {
    updateConsent();
  }, []);

  useEffect(() => {
    let timeout = null;

    if (success) {
      setTimeout(() => {
        setShowMarketingConsentReminder();
      }, 3000);
    }

    return () => {
      clearTimeout(timeout);
      timeout = null;
    };
  }, [success]);

  return {
    optIn,
    success,
    error,
    loading
  };
};

export default useMarketingConsentReminder;
